import Index from '../components/companyGroupEmployer/Index';
import IndexIn from '../components/companyGroupEmployer/IndexIn';
import View from '@/components/common/view'
import EmployerEdit from '../components/companyGroupEmployer/Edit';
import EmployerFillin from '../components/companyGroupEmployer/Fillin';
import EmployerConfirm from '../components/companyGroupEmployer/Confirm';
import EmployerFillinPerson from '../components/companyGroupEmployer/FillinPerson';
import EmployerFillinPersonSuccess from '../components/companyGroupEmployer/FillinPersonSuccess';


export default [
	{
		path:'',
		component:View,
		children:[
			{
				path:'',
				component:Index
			},
			{
				path:'in',
				component:IndexIn
			},
			{
				path:'fillin/:id?',
				component:EmployerFillin
			},
			{
				path:'edit/:id',
				component:EmployerEdit
			},
			{
				path:'confirm/:id?',
				component:EmployerConfirm
			},
			{
				path:'fillin-person/:policyId/:id',
				component:EmployerFillinPerson,
				meta:{
					hideLogin:true
				}
			},
			{
				path:'fillin-person-success',
				component:EmployerFillinPersonSuccess,
				meta:{
					hideLogin:true
				}
			}
		]
	},
]


// WEBPACK FOOTER //
// ./src/pages/haierProduct/router/companyGroupEmployer.js